import { render, staticRenderFns } from "./NewTaskModal.vue?vue&type=template&id=9ca7400e&"
import script from "./NewTaskModal.vue?vue&type=script&lang=js&"
export * from "./NewTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports